import SocialSharing from './SocialSharing';

export default SocialSharing;
